import { render, staticRenderFns } from "./pdproduct1.vue?vue&type=template&id=2a5d6403&scoped=true"
import script from "./pdproduct1.vue?vue&type=script&lang=js"
export * from "./pdproduct1.vue?vue&type=script&lang=js"
import style0 from "./pdproduct1.vue?vue&type=style&index=0&id=2a5d6403&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5d6403",
  null
  
)

export default component.exports